import React, {useEffect, useRef, useState} from "react";
import cx from "classnames"
import styles from "./YearHistory.module.css"
import Image from "next/image";
import Link from "next/link";
import {useInView} from "framer-motion";
import {useRouter} from "next/router";

const YearHistory = ({shamsiDate, miladiDate, yearItems, reverse=false, isLast}) => {
    const [isEn, setIsEn] = useState(false)
    const router = useRouter()

    useEffect(() => {
        if (router.pathname.includes("/en")) {
            setIsEn(true)
        } else {
            setIsEn(false)
        }
    }, [router])

    const [activeItem, setActiveItem] = useState(yearItems[0])

    const refVal1 = useRef()
    const isVal1InView = useInView(refVal1)
    const refVal2 = useRef()
    const isVal2InView = useInView(refVal2)
    const refVal3 = useRef()
    const isVal3InView = useInView(refVal3)
    const refVal4 = useRef()
    const isVal4InView = useInView(refVal4)
    const refVal5 = useRef()
    const isVal5InView = useInView(refVal5)

    return(
        <div className="w-100 d-flex flex-column align-items-center justify-content-start">
            <div
                style={{
                    transform: isVal1InView ? "none" : "translateY(-20px)",
                    opacity: isVal1InView ? 1 : 0,
                    transition: "all ease 1400ms",
                }}
                className="w-100 d-flex flex-column align-items-center justify-content-center mb-3">
                <span className={cx(styles.shamsiDateStyles, "text-white", "d-flex", "align-items-center", "justify-content-center", isEn ? "gilroyFontFamily" : "")}>
                    {shamsiDate}
                    <div ref={refVal1}></div>
                </span>
                <span className={cx(styles.miladiDateStyels, "my-3" , isEn ? "gilroyFontFamily" : "")}>{miladiDate}</span>
                <div className={styles.arrowContainer}>
                    <div className={styles.arrowDown}></div>
                </div>
            </div>
            <div className={`w-100 d-flex align-items-center justify-content-center ${reverse ? 'flex-row-reverse' : ''}`}>
                <div className={`d-lg-flex d-none flex-column align-content-center flex-fill ${reverse ? `justify-content-start ${isEn ? 'me-lg-4' : 'ms-lg-4'}` : `justify-content-end ${isEn ? 'ms-lg-4' : 'me-lg-4'}`}`}>
                    {yearItems.map((item, index) => (
                        <div
                            style={{
                                transform: isVal3InView ? "none" : reverse ? "translateX(-20px)" : "translateX(20px)",
                                opacity: isVal3InView ? 1 : 0,
                                transition: "all ease 1400ms",
                                transitionDelay: `${index * 0.1}s`
                            }}
                            key={index} className={`d-flex align-items-center justify-content-sm-center justify-content-end px-2 px-sm-0 flex-lg-row mb-2 ${reverse ? 'justify-content-lg-start' : 'justify-content-lg-end'}`} onMouseEnter={() => setActiveItem(item)}>
                            {reverse && <Image className={cx(isEn ? "ms-2 ms-lg-0" : "me-2 me-lg-0")} src={item.icon} alt={isEn ? item.textEn : item.text} unoptimized width={25} height={25} />}
                            {item.link === "#" ? (
                                <span className={cx(reverse ? (isEn ? "me-2" : "ms-2") : (isEn ? "ms-2" : "me-2"), styles.linkStyles, styles.noneLink, isEn ? "gilroyFontFamily" : "")}>{isEn ? item.textEn : item.text}</span>
                            ) : (
                                <Link target="_blank" className={cx(reverse ? (isEn ? "me-2" : "ms-2") : (isEn ? "ms-2" : "me-2"), styles.linkStyles, isEn ? "gilroyFontFamily" : "")} href={item.link}>{isEn ? item.textEn : item.text}</Link>
                            )}
                            {!reverse && (<Image className={cx(isEn ? "ms-2 ms-lg-0" : "me-2 me-lg-0")} src={item.icon} alt={isEn ? item.textEn : item.text} unoptimized
                                    width={25} height={25}/>)}
                            <div ref={refVal3}></div>
                        </div>
                    ))}
                </div>
                <div className={cx(styles.yearItemSmall, "d-flex","d-lg-none", "flex-column", "align-items-start", "justify-content-start")}>
                    {yearItems.map((item, index) => (
                        <div
                            style={{
                                transform: isVal5InView ? "none" : "translateX(-20px)",
                                opacity: isVal5InView ? 1 : 0,
                                transition: "all ease 1400ms",
                                transitionDelay: `${index * 0.1}s`
                            }}
                            key={index} className={`d-flex align-items-start justify-content-sm-center justify-content-end px-2 px-sm-0 flex-lg-row mb-2 ${reverse ? 'justify-content-lg-start' : 'justify-content-lg-end'}`} onMouseEnter={() => setActiveItem(item)}>
                            <Image className={cx(isEn ? "ms-2 ms-lg-0" : "me-2 me-lg-0")} src={item.icon} alt={isEn ? item.textEn : item.text} unoptimized width={25} height={25} />
                            {item.link === "#" ? (
                                <span className={cx(reverse ? (isEn ? "me-2" : "ms-2") : (isEn ? "ms-2" : "me-2"), styles.linkStyles, styles.noneLink, isEn ? "gilroyFontFamily" : "")}>{isEn ? item.textEn : item.text}</span>
                            ) : (
                                <Link target="_blank" className={cx(reverse ? (isEn ? "me-2" : "ms-2") : (isEn ? "ms-2" : "me-2"), styles.linkStyles, isEn ? "gilroyFontFamily" : "")} href={item.link}>{isEn ? item.textEn : item.text}</Link>
                            )}
                            <div ref={refVal5}></div>
                        </div>
                    ))}
                </div>
                <div
                    style={{
                        transform: isVal2InView ? "none" : reverse ? "translateX(20px)" : "translateX(-20px)",
                        opacity: isVal2InView ? 1 : 0,
                        transition: "all ease 1400ms",
                    }}
                    className={cx(styles.imageWrapper, "d-lg-flex", "flex-fill", "d-none", "position-relative", reverse ? 'justify-content-end' : 'justify-content-start')}>
                    <Image src={activeItem.image} alt={activeItem.text} unoptimized width={100} height={100} />
                    <div className="position-absolute" ref={refVal2}></div>
                </div>
            </div>
            {!isLast && (<div
                style={{
                    transform: isVal4InView ? "none" : "translateY(20px)",
                    opacity: isVal4InView ? 1 : 0,
                    transition: "all ease 1400ms",
                }}
                className="w-100 d-flex align-items-center justify-content-center mt-3">
                <span className={cx(styles.verticalLine, "d-flex")}></span>
                <div ref={refVal4}></div>
            </div>)}
        </div>
    )
}

export default YearHistory